module.exports = __webpack_public_path__ + "img/anonymous-mask.2568df78.png";